export default {
  getTemplate: (state) => {
    return state.template;
  },

  getTemplates: (state) => {
    return state.templates;
  },

  getCampaigns: (state) => {
    return state.campaigns;
  },

  getCampaign: (state) => {
    return state.campaign;
  },

  getFormats: (state) => {
    return state.formats;
  },

  getFormat: (state) => {
    return state.format;
  },

  getImages: (state) => {
    return state.images;
  },

  getCurrentImageIndex: (state) => {
    return state.currentImageIndex;
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/template-images/getters.js